export default {
  // 登录
  userLogin: { url: '/v1/sys/user/login' },
  // 注册
  register: { url: '/v1/sys/user/register' },
  // 退出登录
  outLogin: { url: '/v1/sys/user/outLogin' },
  // 短信验证码
  smsSend: { url: '/v1/sys/sms/send' },
  // 短信登录
  smsLogin: { url: '/v1/sys/user/smsLogin' },
  // 短信验证
  smsCheck: { url: '/v1/sys/sms/check' },
};
